import { render, staticRenderFns } from "./Commentdetail.vue?vue&type=template&id=3549d125"
import script from "./Commentdetail.vue?vue&type=script&lang=js"
export * from "./Commentdetail.vue?vue&type=script&lang=js"
import style0 from "./Commentdetail.vue?vue&type=style&index=0&id=3549d125&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports